import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../redux/hooks";

function PrivateRoute() {
  const { user, isLoading } = useAppSelector((state) => state.auth);
  return user && !isLoading ? <Outlet /> : <Navigate to="/login" />;
}

export default PrivateRoute;
